<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-08-11 14:47:18
 * @LastEditTime: 2021-08-12 12:02:07
 * @Description: 材料成本详情
 * @Param:
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\statisticalAnalysis\materialCost\materialCostDetails.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="materialCostDetails">
            <van-nav-bar
                :title="title"
                left-arrow
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <ul>
                    <li>
                        <div>
                            <h4>总产量(方)</h4>
                        </div>
                        <div>
                            <div style="background:#0091FF;">
                                <i class="iconfont iconlifangtilitiduomiantifangkuai"></i>
                            </div>
                            <p>{{ detailsData.volume || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>平均售价</h4>
                        </div>
                        <div>
                            <div style="background:#7954FF;">
                                <i class="iconfont iconxiaoshoujia"></i>
                            </div>
                            <p>{{ detailsData.unit_price || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>总材料成本</h4>
                            <span class="spanStyle1">实际</span>
                        </div>
                        <div>
                            <div style="background:#F7B500;">
                                <i class="iconfont iconcaiwuhesuan"></i>
                            </div>
                            <p>{{ detailsData.all_cost || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>单方材料成本</h4>
                            <span class="spanStyle2">实际</span>
                        </div>
                        <div>
                            <div style="background:#21BC9A;">
                                <i class="iconfont iconcaiwuguanli"></i>
                            </div>
                            <p>{{ detailsData.unit_cost || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>总材料成本</h4>
                            <span class="spanStyle3">平均</span>
                        </div>
                        <div>
                            <div style="background:#F15545;">
                                <i class="iconfont iconcaiwuhesuan"></i>
                            </div>
                            <p>{{ detailsData.b4f4 || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>单方材料成本</h4>
                            <span class="spanStyle4">平均</span>
                        </div>
                        <div>
                            <div style="background:#00B3FE;">
                                <i class="iconfont iconcaiwuguanli"></i>
                            </div>
                            <p>{{ detailsData.b_unit_cost || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>单方差值</h4>
                        </div>
                        <div>
                            <div style="background:#0091FF;">
                                <i class="iconfont iconchaji"></i>
                            </div>
                            <p>{{ detailsData.d4f4 || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>总成本差值</h4>
                        </div>
                        <div>
                            <div style="background:#7853FF;">
                                <i class="iconfont iconchaji"></i>
                            </div>
                            <p>{{ detailsData.c4e4 || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>单方毛利</h4>
                        </div>
                        <div>
                            <div style="background:#F7B500;">
                                <i class="iconfont iconlirunbiaoselected"></i>
                            </div>
                            <p>{{ detailsData.h4d4 || 0 }}</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <h4>总毛利</h4>
                        </div>
                        <div>
                            <div style="background:#21BC9A;">
                                <i class="iconfont iconlirunbiaoselected"></i>
                            </div>
                            <p>{{ detailsData.b4h4c4 || 0 }}</p>
                        </div>
                    </li>
                </ul>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    name: 'material-cost-details',
    components: {},
    props: {},
    data() {
        return {
            title: '',
            detailsData: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.params.item) {
            this.title = this.$route.params.item.NAMES || '详情';
            this.detailsData = this.$route.params.item;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus" scoped>
.materialCostDetails
    height 100%
    section
        height calc(100% - 44rpx)
        padding 14rpx 14rpx 0 14rpx
        ul
            width 100%
            display flex
            flex-wrap wrap
            li
                padding 14rpx
                margin-right 17rpx
                margin-bottom 14rpx
                width calc(50% - 9rpx)
                background url(./images/bg.png) no-repeat
                background-size 100% 100%
                &:nth-of-type(even)
                    margin-right 0
                div
                    display flex
                    &:nth-of-type(1)
                        h4
                            font-size 12rpx
                            color #666666
                            margin-right 5rpx
                            line-height 18rpx
                        span
                            font-size 12rpx
                            padding 0 3rpx
                            line-height 16rpx
                            border-radius 3rpx
                            &.spanStyle1
                                border 1px solid #F6B400
                                color #F6B400
                            &.spanStyle2
                                border 1px solid #21BB99
                                color #21BB99
                            &.spanStyle3
                                border 1px solid #F05545
                                color #F05545
                            &.spanStyle4
                                border 1px solid #00B3FE
                                color #00B3FE
                    &:nth-of-type(2)
                        margin-top 15rpx
                        div
                            width 22rpx
                            height 22rpx
                            border-radius 3rpx
                            margin-right 10rpx
                            display flex
                            align-items center
                            justify-content center
                            i
                                color #fff
                                font-size 12rpx
                        p
                            font-size 18rpx
                            line-height 22rpx
                            color #333333
                            font-weight 600
</style>